<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="delete-template"
  >
    <v-card>
      <v-card-title>
        <h3>Delete this template?</h3>
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to delete this template?</p>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Cancel</v-btn>

        <v-btn color="error darken-1" @click="confirmDialog" :disabled="loading">
          <v-icon left v-if="!loading">fas fa-trash</v-icon>
          <v-icon left v-else>fas fa-spinner fa-spin</v-icon>
          DELETE
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
  props: ["showDeleteTemplateDialog", "templateId"],
  computed: {
    showDialog: {
      get() {
        return this.showDeleteTemplateDialog;
      },
      set(value) {
        this.$emit("update:showDeleteTemplateDialog", value);
      }
    }
  },
  watch: {
    showDeleteTemplateDialog() {
      this.loading = false;
    }
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.loading = true;
      this.$emit("confirmDeleteTemplateDialog", this.templateId);
    }
  }
};
</script>

<style scoped>
.delete-template h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.delete-template h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.delete-template p {
  font-weight: 500;
}

.delete-template p:nth-child(2) {
  margin-top: -15px;
}

.delete-template .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}
</style>